import type { ISelectItem, IItemWithLocation } from '~/types/models'

const mn = '[cynqueModules/dataObjects/LocationCounts]'

export function countUniqueLocations(itemsWithLocation: IItemWithLocation[]): {
  location: ISelectItem
  count: number
}[] {
  const fn = `${mn} countUniqueLocations |`
  console.debug(`${fn} counting ${itemsWithLocation.length} items`)
  const locationList = itemsWithLocation.map(
    (itemWithLocation) => itemWithLocation.location
  )
  const map = Map.groupBy(locationList, (location) => location.id)
  const countsList = [...map.values()].map((value) => ({
    location: value[0],
    count: value.length,
  }))
  return countsList.sort((a, b) =>
    a.location.label.localeCompare(b.location.label)
  )
}
